import React from 'react';
import { useHistory, useLocation } from 'react-router';
import helper from '../../../../../utils/helper';
import { Button } from '../../../../UI/Common';
import {
  getSharedDefaultStyles,
  getSpacingAround,
} from '../../../Configure/DashboardCustom/functions';
import AGComponent from './AGComponent';
import CMVComponent from './CMVComponent';

const AvailableGroupsWidget = (props) => {
  const location = useLocation();
  const history = useHistory();
  const { groupId, groupName, state } = helper.parseQueryString(
    location.search,
  );
  function getStyles() {
    let val = parseInt(props.width);
    return {
      width: val < 0 ? '100%' : val,
      ...getSharedDefaultStyles(),
      ...getSpacingAround(
        props.extraProperties.spacingTop,
        props.extraProperties.spacingRight,
        props.extraProperties.spacingBottom,
        props.extraProperties.spacingLeft,
      ),
    };
  }
  return (
    <div style={getStyles()}>
      {groupId ? (
        <div>
          <Button onClick={() => history.goBack(-1)}>Back</Button>
        </div>
      ) : null}
      {groupId ? (
        <CMVComponent
          {...props}
          groupId={groupId}
          groupName={groupName}
          groupState={state}
        />
      ) : (
        <AGComponent {...props} />
      )}
    </div>
  );
};

export default AvailableGroupsWidget;
